import { Button, Col, Container, Row } from "react-bootstrap";
import { Parallax } from 'react-scroll-parallax';
import ScrollAnimation from "react-animate-on-scroll";
import { MdOutlineBusinessCenter, MdOutlineHandshake, MdOutlineEventNote, MdOutlineSupervisedUserCircle } from "react-icons/md";
import Service from "../components/Service";
import Product from "../components/Product";
import Partner from "../components/Partner";
import CallUs from "../components/CallUs";
import OurTalent from "../components/OurTalent";
import ForTalent from "../components/ForTalent";
import Offer from "../components/Offer";
import ProblemSolve from "../components/ProblemSolve";
import Apps from "../components/Apps";
import MobileApp from "../components/MobileApp";

const Home = () => {

    const scrollTo = (id:string) => {
        const element = document.getElementById(id);
        const headerOffset = 70;
        if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
           });
        }
    }

    return(
        <div>
            <Container id="home">
                <div className="main-content">
                    <Parallax speed={-20} className="main-parallax-3"/>
                    <Parallax speed={30} className="main-parallax-2"/>
                    <Parallax speed={-15} className="main-parallax-1"/>
                    <div className="content-wrapper fade-in-text">
                        <div className="subtitle">Jelajahi TEMA Hari Ini</div>
                        <div className="title">Solusi Cerdas Untuk Optimasi Tenaga Kerja</div>
                        <div className="desc">TEMA adalah solusi outsourcing modern yang berfokus pada penyediaan tenaga kerja sales activation, khususnya SPG/SPB profesional dalam berbagai tier.</div>

                        <Row className="mt-4">
                            <Col md={'auto'} className="mb-2">
                                <Button variant="brand" onClick={() => scrollTo("principal")}><strong>Partner Bisnis</strong></Button>
                            </Col>
                            <Col md={'auto'} className="mb-2">
                                <Button variant="outline-brand" onClick={() => scrollTo("for-talent")}><strong>Sebagai Talent</strong></Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
            <div className="about-us bg-brand-opacity pt-5 pb-3" id="about-us">
                <Container className="pt-5 pb-5">
                    <Row>
                        <Col sm={12} md={5} lg={5}>
                            <div className="about-us-image-wrapper">
                                <Parallax speed={0} className="about-us-parallax-1"/>
                                <Parallax speed={-10} className="about-us-parallax-3"/>
                                <Parallax speed={30} className="about-us-parallax-2"/>
                            </div>
                        </Col>
                        <Col sm={12} md={7} lg={7}>
                            <ScrollAnimation animateIn='bounce' animateOnce={true}>
                                <strong className="text-brand">TENTANG KAMI</strong>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                                <div className="header mt-4 text-black">Partner strategis Untuk Kesuksesan Aktivitas Promosi Anda</div>
                                <p className="mt-4">TEMA menyediakan tenaga kerja promosi dengan klasifikasi peran yang dapat disesuaikan dengan kebutuhan program klien — mulai dari Brand Representative untuk campaign premium & aktivitas penjualan harian di lapangan hingga Layanan Aktivasi & Manajemen Event.</p>
                                <p>Kelola seluruh tim Anda secara terintegrasi dengan aplikasi dan dashboard digital TEMA. Kami hadir dengan ekosistem lengkap untuk mendukung tenaga kerja dengan berbagai syarat dan kebutuhan. Dengan layanan tim lapangan yang andal, bisnis Anda siap menembus pasar dengan lebih cepat dan efektif.</p>
                            </ScrollAnimation>

                            <div className="mt-3">
                                <div className="service-list">
                                    <ScrollAnimation animateIn='fadeInRight' delay={0} animateOnce={true}>
                                        <div className="list">
                                            <MdOutlineSupervisedUserCircle/>
                                            <div className="desc">Outsourcing Tenaga Kerja</div>
                                        </div>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn='fadeInRight' delay={100} animateOnce={true}>
                                        <div className="list">
                                            <MdOutlineHandshake/>
                                            <div className="desc">Layanan Aktivasi & Promosi</div>
                                        </div>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn='fadeInRight' delay={200} animateOnce={true}>
                                        <div className="list">
                                            <MdOutlineEventNote/>
                                            <div className="desc">Manajemen Event</div>
                                        </div>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Offer/>

            <div id="principal">
                <Service/>
            </div>

            {/* <ProblemSolve/> */}

            <Product/>

            <MobileApp/>

            <div style={{height:"10vh"}}/>

            <Apps/>

            <Partner/>

            {/* <OurTalent/> */}

            <CallUs/>
            
            <div id="for-talent">
                <ForTalent/>
            </div>
        </div>
    )
}

export default Home